import { useContext } from "react";

import { FormType } from "@simplyk/common";

import { useFormV2Context } from "../../../contexts/FormV2Context";

import { FrontendFormContext } from "@/common/contexts/FrontendFormContext";

export type GiveAsSectionRenderPosition = "express-checkout" | "buyer-information";

export const useGiveAsSectionRenderPosition = (): GiveAsSectionRenderPosition => {
  const { type } = useFormV2Context();
  const { displayExpressCheckout, displayedFormAmount } = useContext(FrontendFormContext);

  const isFreeTicketSelection = type === FormType.Ticketing && displayedFormAmount === 0;

  return displayExpressCheckout && !isFreeTicketSelection ? "express-checkout" : "buyer-information";
};
